export default __webpack_public_path__ + "static/media/Path left.d39bad8f.svg";